import { c as _c } from "react/compiler-runtime";
import { Button as ButtonHeadlessUI } from '@headlessui/react';
import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { format } from 'date-fns';
import { H4 } from '@/frontend/design-system/_marketing/typography/Heading';
import { cn } from '@/frontend/utils';
export type CalendarEvent = {
  id?: string;
  startTime: Date;
  organizerEmail?: string;
  summary?: string;
  isBooked?: boolean;
  isRecurring?: boolean;
};
export interface CalendarEventProps {
  event: CalendarEvent;
  isChecked: boolean;
  handleSelectedEvent: () => void;
  isRecurring?: boolean;
}
export function Event(t0) {
  const $ = _c(17);
  const {
    event,
    handleSelectedEvent,
    isChecked,
    isRecurring: t1
  } = t0;
  const isRecurring = t1 === undefined ? false : t1;
  const t2 = isChecked && "border-blue-100 bg-blue-50";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex h-fit items-center justify-center gap-2 rounded-md border border-borderPrimary bg-backgroundSecondary p-4", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = event.isBooked;
  const t5 = isChecked && "text-contentBlue";
  let t6;
  if ($[2] !== t5) {
    t6 = cn("text-contentSecondary", t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== event.startTime) {
    t7 = format(event.startTime, "HH:mm");
    $[4] = event.startTime;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = <H4 className={t6}>{t7}</H4>;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== isRecurring) {
    t9 = isRecurring && <ArrowPathIcon className="h-4 w-4 flex-none text-contentBlue" />;
    $[9] = isRecurring;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== event.isBooked || $[12] !== handleSelectedEvent || $[13] !== t3 || $[14] !== t8 || $[15] !== t9) {
    t10 = <ButtonHeadlessUI className={t3} disabled={t4} onClick={handleSelectedEvent}>{t8}{t9}</ButtonHeadlessUI>;
    $[11] = event.isBooked;
    $[12] = handleSelectedEvent;
    $[13] = t3;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}